// extracted by mini-css-extract-plugin
module.exports = {"scoreItem":"ScoreItem_scoreItem__2KcLO","imgWrapper":"ScoreItem_imgWrapper__V3756","textRed":"ScoreItem_textRed__3sP9d","textBlue":"ScoreItem_textBlue__2Si4x"};